import { call, put, takeLatest } from 'redux-saga/effects';

import { getEmailApiCall } from './emailAPI.js';
import { emailsError, emailsRequest, emailsStore } from './emailsActions.js';

function* getEmailsSaga({ payload }) {
  console.log('payload getEmailsSaga', payload);
  const { id, navigate } = payload;

  try {
    const { data: emails } = yield call(getEmailApiCall, id);
    yield put(emailsStore({ emails }));
    yield put(navigate(`/email/content`));
  } catch (error) {
    console.log('getEmailsSaga error', error.toString());
    yield put(emailsError(error.Message ? error.Message : error.toString()));
  }
}

export function* getEmailsWatcher() {
  yield takeLatest(emailsRequest.type, getEmailsSaga);
}
